import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getUser, initApp, startRedirect, phoneFieldChange, textLink } from '../../actions';
import { Spinner, Card, Input, Error } from '../common';

import DocumentTitle from 'react-document-title';
import Intercom from 'react-intercom';
import moment from 'moment';

class Dashboard extends Component {

  componentWillMount() {

    this.detectUser();


  }


  formatUsPhone(phone) {
    var phoneTest = new RegExp(/^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/);

    phone = phone.trim();
    var results = phoneTest.exec(phone);
    if (results !== null && results.length > 8) {
      return "(" + results[3] + ") " + results[4] + "-" + results[5] + (typeof results[8] !== "undefined" ? " x" + results[8] : "");
    }
    else {
         return phone;
    }
  }




  detectUser() {
    const token = window.localStorage.getItem('token');
    if (token !== null) {
      if(!this.props.init){
        this.props.getUser({token});
      }
    }else{
      if(!this.props.init){
        this.props.initApp("dashboard_redirect");
      }
    }
  }

  submitForm(ev){
    ev.preventDefault();
    const text = 'Thanks for applying to work with '+this.renderTeamName()+'! Follow these steps to get started: \n1.) Open this link with your phone to download the mobile app: https://dealmachine.app.link/download \n2.) Click "Login" in the top right \n3.) Sign in with '+this.props.user.email+'\n4) Say hi to your team owner: '+this.props.user.team_email;
    this.props.textLink({ token:this.props.token, phone_number: this.props.phone, text: text });
  }

  renderSpinner() {
    if(this.props.loading || this.props.text_loading){
      return <Spinner />
    }
  }

  renderError() {
    if(this.props.error){
      return<Error text={this.props.error}/>;
    }else if(this.props.text_error){
      return<Error text={this.props.text_error}/>;
    }
  }
  renderTeamName(){
    if(this.props.user){
      if(this.props.user.team_company && this.props.user.team_company !== ""){
        return this.props.user.team_company;
      }else{
        return this.props.user.team_name;
      }
    }
    return "";
  }
  render() {

      if(this.props.init && this.props.user){


        const user = {
          user_id: this.props.user.id,
          email: this.props.user.email,
          name: this.props.user.firstname+" "+this.props.user.lastname,
          phone: this.props.user.phone,
          signed_up_at: moment(this.props.user.date_created).format("X"),
          custom_attributes: this.props.user.intercom_data
        }

        return (
          <DocumentTitle title='DealMachine'>
            <div className="dashboard-wrapper">
              <div className="dashboard-inner animated fadeIn">
                <Intercom appID="sfur1js7" { ...user } />
                <div>
                  <h2>Step 2 of 3:</h2>
                  <h3><b>Get the app</b></h3>
                  <p>Welcome, {this.props.user.firstname}.</p>
                  <p>Adding properties only takes 10 seconds. <b>{this.renderTeamName()}</b> is providing you with access to the DealMachine so you can start adding properties. Enter your phone number to be texted a link to download the app.</p>
                </div>

                <form onSubmit={this.submitForm.bind(this)}>

                  <Card>
                    <Input
                      label="Phone Number"
                      value={this.props.phone}
                      onChange={ ev => this.props.phoneFieldChange(ev.target.value)}
                      type={"text"}
                      mask={"(999) 999-9999"}
                    />
                  </Card>

                  <div className="flex-item card">
                    <button className="primary-button flex-item" type="submit">
                      Send Link
                    </button>
                  </div>
                </form>

                <div style={{marginTop: 40}}>
                  <h2>Step 3 of 3:</h2>
                  <h3><b>IMPORTANT - HOW TO GET PAID</b></h3>
                  <p>Please reach out to <b>{this.props.user.team_name}{this.props.user.team_company && this.props.user.team_company !=="" ? " from "+this.props.user.team_company+" " : ""}</b> at <a href={'mailto:'+this.props.user.team_email}>{this.props.user.team_email}</a> or <a href={'tel:'+this.props.user.team_phone}>{this.props.user.team_phone}</a> to discuss your payment terms. Payment arrangements will be made directly between YOU and <b>{this.renderTeamName()}</b>. DealMachine provides technology for adding properties and communicating with your team. Payments are not made through or by the DealMachine app or DealMachine LLC in any way.</p>
                </div>

              </div>
              {this.renderSpinner()}
              {this.renderError()}
            </div>


          </DocumentTitle>
        );
      }else{
        return (
          <DocumentTitle title='DealMachine'>
            <Spinner />
          </DocumentTitle>
        );
      }
  }
};

const mapStateToProps = ({ auth, common }) => {
  const { init, device_type, user, token, onboarding,  } = auth;
  const { phone, text_loading, text_error } = common;
  return { init, device_type, user, token, onboarding, phone, text_loading, text_error };
}

export default withRouter(connect(mapStateToProps, { getUser, initApp, startRedirect, phoneFieldChange, textLink })(Dashboard));



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js